"use client";
import useSWR from "swr";
import { ServicePingInfo, ServiceUserDonorStatus, ServiceUserGivingHistory, ServiceUserPaymentProfileClientToken, ServiceUserSubscriberStatus, ServiceUserWithAdminInfo } from "../../../../shared/validated-servertypes";
import { clientGetFetcher } from "./dpfetcher";
import { clientGetAuthenticatedFetcher } from "./dpfetcher";
export function useStatus() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["kping", undefined], ([api, params]) => clientGetFetcher(api, params), {
        refreshInterval: 60000
    });
    if (error) {
        return ({
            serviceInfo: undefined,
            isLoading: isLoading,
            errorObject: error
        });
    }
    return ({
        serviceInfo: data ? ServicePingInfo.parse(data) : undefined,
        isLoading: isLoading,
        errorObject: error
    });
}
export function useUser() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["getCurrentUser", undefined], ([api]) => clientGetAuthenticatedFetcher(api, undefined), {
        refreshInterval: 60000
    });
    if (error) {
        return ({
            user: undefined,
            isAdmin: false,
            adminRole: "none",
            isLoading: isLoading,
            errorObject: error
        });
    }
    if (!data) {
        return ({
            user: undefined,
            isAdmin: undefined,
            adminRole: undefined,
            isLoading: isLoading,
            errorObject: undefined
        });
    }
    const suwa = ServiceUserWithAdminInfo.parse(data);
    return ({
        user: suwa,
        isAdmin: (suwa.adminRole !== "none"),
        adminRole: suwa.adminRole,
        isLoading: isLoading,
        errorObject: undefined
    });
}
export function useDonorStatus() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["getDonorStatus", undefined], ([api]) => clientGetAuthenticatedFetcher(api, undefined), {
        refreshInterval: 60000
    });
    if (error) {
        return ({
            donorStatus: undefined,
            isLoading: isLoading,
            errorObject: error
        });
    }
    return ({
        donorStatus: data ? ServiceUserDonorStatus.parse(data) : undefined,
        isLoading: isLoading,
        errorObject: undefined
    });
}
export function useSubscriberStatus() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["getSubscriberStatus", undefined], ([api]) => clientGetAuthenticatedFetcher(api, undefined), {
        refreshInterval: 60000
    });
    if (error) {
        return ({
            subscriberStatus: undefined,
            isLoading: isLoading,
            errorObject: error
        });
    }
    return ({
        subscriberStatus: data ? ServiceUserSubscriberStatus.parse(data) : undefined,
        isLoading: isLoading,
        errorObject: undefined
    });
}
export function useDefaultPaymentProfileClientToken() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["getDefaultPaymentProfileClientToken", undefined], ([api]) => clientGetAuthenticatedFetcher(api, undefined));
    if (error) {
        return ({
            ppct: undefined,
            isLoading: isLoading,
            errorObject: error
        });
    }
    return ({
        ppct: data ? ServiceUserPaymentProfileClientToken.parse(data) : undefined,
        isLoading: isLoading,
        errorObject: undefined
    });
}
export function useGivingHistory() {
    // NOTENOTE: error object type from useSWR
    const { data, error, isLoading } = useSWR(["getGivingHistory", undefined], ([api]) => clientGetAuthenticatedFetcher(api, undefined), {
        refreshInterval: 60000
    });
    if (error) {
        return ({
            givingHistory: undefined,
            isLoading: isLoading,
            errorObject: error
        });
    }
    return ({
        givingHistory: data ? ServiceUserGivingHistory.parse(data) : undefined,
        isLoading: isLoading,
        errorObject: undefined
    });
}
